<template>
    <div :class="['status', journey.statusName]"
         :style="{width: journey.percent + '%'}"
         @click.passive="activeJourney(journey)"
         v-click-outside="{
                method: outside,
                exclude: ['.journey-details']
            }"
    >
        <div class="journey-details" v-if="isActive">
            <div class="journey-status">{{ journey.statusName }}</div>
            <div class="content">
                <div class="point"><span class="text-bold">Start:</span> {{ journey.startAddress }}</div>
                <div class="point"><span class="text-bold">End:</span> {{ journey.endAddress }}</div>
                <div class="time-period"><span class="text-bold">Journey time:</span> {{ journey.startTime }} to {{ journey.endTime }}</div>
            </div>
        </div>
    </div>

</template>

<script>
import moment from 'moment'
import { getEventTargetName } from '../../../helpers/Utils'

export default {
    name: 'JourneyDetails',
    props: {
        journey: {
            required: true
        },
        index: {
            required: true
        }
    },
    data () {
        return {
            isActive: false
        }
    },
    methods: {
        async activeJourney (journey) {
            this.$store.state.isOverlayActive = true

            this.isActive = !this.isActive
            this.$store.state.isOverlayActive = false

            await this.$emit('active-journey', journey)
        },
        showTime (date) {
            return moment(date).format('HH:mm:ss')
        },
        outside () {
            this.isActive = false
        }
    },
    directives: {
        'click-outside': {
            bind: function (el, binding, vNode) {
                const { exclude } = binding.value

                const bubble = binding.modifiers.bubble

                const handler = (e) => {
                    let targetName = getEventTargetName(e.target)
                    if (bubble || (!el.contains(e.target) && el !== e.target && !exclude.includes(targetName))) {
                        binding.value.method(e)
                    }
                }
                el.__vueClickOutside__ = handler

                document.addEventListener('click', handler)
            },
            unbind: function (el, binding) {
                document.removeEventListener('click', el.__vueClickOutside__)
                el.__vueClickOutside__ = null
            }
        }
    }
}
</script>

<style scoped lang="scss">
.status {
    height: 25px;
    cursor: pointer;
    position: relative;
    z-index: 7;

    &:hover {
        &.driving {
            background: rgba($success, 0.7);
        }

        &.offline,
        &.nogps {
            background: rgba($danger, 0.7);
        }

        &.sleep {
            background: rgba($info, 0.7);
        }

        .journey-details {
            opacity: 1;
            display: block;
        }
    }

    &.driving {
        background: $success;
    }

    &.offline,
    &.nogps {
        background: $danger;
    }

    &.sleep {
        background: $info;
    }

    .journey-details {
        position: absolute;
        background: white;
        display: block;
        font-size: 13px;
        line-height: 15px;
        min-width: 250px;
        /*border: 1px solid black;*/
        box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);
        z-index: 10;
        top: 48px;

        .journey-status {
            background: $light-gray;
            padding: 9px 20px;
            font-weight: 600;
            font-size: 16px;
        }

        .content {
            padding: 15px 20px;
            font-weight: 300;
            font-size: 14px;
            line-height: 19px;
        }
    }
}
</style>
